import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    excelContainer: {
      height: 'calc(100vh - 160px)',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1.5),
      boxSizing: 'border-box',
      background: '#fff',
      minHeight: 0,
    },
    excelTitle: {
      marginBottom: theme.spacing(1),
      fontWeight: 700,
      fontSize: 16,
    },
    sheetTabContainer: {
      marginTop: theme.spacing(1.5),
      display: 'flex',
      gap: theme.spacing(0.25),
      alignSelf: 'flex-start',
      position: 'sticky',
      bottom: 0,
      width: '100%',
      zIndex: 3,
      background: '#fff',
      padding: theme.spacing(1, 0),
      boxShadow: '0 -1px 6px rgba(0,0,0,0.06)',
    },
    sheetTabButton: {
      padding: `${theme.spacing(0.75)}px ${theme.spacing(1.25)}px`,
      border: '1px solid #ddd',
      cursor: 'pointer',
      background: '#fff',
      '&:hover': {
        background: '#f5f5f5',
      },
      borderRadius: '0px 0px 12px 12px',
    },
    tableContainer: {
      borderCollapse: 'collapse',
      width: '100%',
      fontSize: '12px',
      flex: 1,
      overflow: 'auto',
      minHeight: 0,
      paddingBottom: theme.spacing(6),
      '& thead': {
        position: 'sticky',
        top: 0,
        zIndex: 2,
      },
      '& table': {
        width: '100%',
      },
      // alternate row backgrounds
      '& tbody tr:nth-of-type(odd)': {
        background: '#ffffff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#fbfbfb',
      },
    },
    tableHeader: {
      border: '1px solid #ddd',
      padding: theme.spacing(1),
      textAlign: 'left',
      fontWeight: 700,
      fontSize: '14px',
      background: '#f3f6f9',
    },
    tableRow: {
      border: '1px solid #eee',
      padding: theme.spacing(1),
      whiteSpace: 'pre-wrap',
    },
    code: {
      margin: '0px !important',
      padding: `0px ${theme.spacing(3)}px ${theme.spacing(2)}px !important`,
      borderRadius: '8px',
      fontSize: '0.75rem',
      lineHeight: '0.9425rem',
      backgroundColor: `${theme.palette.grey[100]} !important`,
      fontWeight: 400,
      display: 'block',
      overflow: 'auto',

      '& .react-syntax-highlighter-line-number.linenumber': {
        paddingRight: '1rem!important',
        fontSize: '0.75rem',
        color: theme.palette.grey[400],
      },
    },
    mainContainer: {
      padding: theme.spacing(1.5),
    },
  }),
);
